export default __webpack_public_path__ + "media/Bitbucket_tablet.4765f42604fed6bb733e3499afabd8c0.svg";